module.exports = __webpack_public_path__ + "static/OGWII_S1-11.2_lazienka_pietro_01-2c4f8115cffa4c2af92ea715ed8f6a84.jpg";